import { createSlice } from "@reduxjs/toolkit";

const initialSellerState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  sellers: [],
  countSellers: 0
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const sellerSlice = createSlice({
  name: 'seller',
  initialState: initialSellerState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    sellersFetched: (state, action) => {
      const {data} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.sellers = data.data ? data.data : [];
      state.countSellers = data.count ? data.count : 0
    },

    catchError: (state, action) => {
      state.lastError = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      } else {
        state.importLoading = false;
      }
    },
  },
});
